import React, { useCallback } from 'react'
import { isNotNilOrEmpty } from '@neo/ramda-extra'
import { PropTypes } from 'prop-types'

import { useField } from 'formik'
import { MultiSelectInput } from './MultiSelectInput'

function ValidatedMultiSelectField({
  name,
  label,
  placeholder,
  items,
  variant,
  onChange,
  errorMsgSelector = (error) => error,
  // Select value (key) for the underneath multi select input, NOT the formik value
  valueSelector = (values) => values,
  displayTextSelector = (values) => values,
  ...props
}) {
  const [field, meta, helpers] = useField({ name, multiple: true, ...props })

  const { value } = field

  const { error, touched } = meta

  const { setValue, setTouched } = helpers

  const defaultOnChange = useCallback(
    (selectedItems) => {
      setValue(selectedItems)
    },
    [setValue]
  )

  return (
    <MultiSelectInput
      value={valueSelector(value)}
      displayTextSelector={displayTextSelector}
      error={error}
      hasError={touched && isNotNilOrEmpty(error)}
      variant={variant}
      errorMsgSelector={errorMsgSelector}
      onChange={onChange || defaultOnChange}
      onBlur={() => {
        setTouched(field.name, true)
      }}
      label={label}
      placeholder={placeholder}
      items={items}
    />
  )
}

const { arrayOf, shape, string } = PropTypes

ValidatedMultiSelectField.propTypes = {
  items: arrayOf(
    shape({
      key: string.isRequired,
      label: string.isRequired,
    })
  ),
}

export { ValidatedMultiSelectField }
